module.exports = __webpack_public_path__ + "static/media/checkin.af6f1382.png";